import script from "./BulmaRadio.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulmaRadio.vue?vue&type=script&setup=true&lang=ts"

import "./BulmaRadio.vue?vue&type=style&index=0&id=3482db7a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3482db7a"]])

export default __exports__